import { Component } from '../Component'
import { inject } from '../../services/di'
import { element } from '../CustomElement'
import Glide, {
    Controls,
    Autoplay,
    Swipe,
} from '@glidejs/glide/dist/glide.modular.esm'

import { ConfigService, Experience } from '../../services/ConfigService'
import { LocationService } from '../../services/LocationService'
import { UserAgentService } from '../../services/UserAgentService'
import { BlackFridayService } from '../../services/BlackFridayService'
import { DateTimeService } from '../../services/DateTimeService'
import { ProudlyCanadianBanner } from '../flipp-proudly-canadian-banner/ProudlyCanadianBanner'
import { ACTIVE_BANNERS, BannerService } from '../../services/BannerService'
import { GiveawayBanner } from '../flipp-giveaway-banner/GiveawayBanner'

@element('listing-page-banner')
export class ListingPageBanner extends Component<any, any> {
    @inject config: ConfigService
    @inject location: LocationService
    @inject userAgent: UserAgentService
    @inject bf: BlackFridayService
    @inject bannerService: BannerService
    @inject dateService: DateTimeService

    glide: any

    refs: {
        regularBannerControl: HTMLButtonElement
        giveawayBannerControl: HTMLButtonElement
    }

    onRender() {
        if (
            this.bannerService.shouldDisplayCarousel() &&
            this.config.EXPERIENCE !== Experience.SDE
        ) {
            setTimeout(() => {
                this.glide = new Glide('.glide', {
                    autoplay: 10000,
                    rewind: true,
                    animationTimingFunc: 'ease-in-out',
                    animationDuration: 750,
                    rewindDuration: 750,
                }).mount({ Controls, Autoplay, Swipe })

                this.glide.on(['swipe.start', 'move'], () => {
                    this.updateControlView()
                })
            })
        }
    }

    render() {
        if (this.config.EXPERIENCE === Experience.SDE) return null

        return this.bannerService.shouldDisplayCarousel()
            ? this.renderCarousel()
            : this.renderBanner()
    }

    renderBanner() {
        const banners = ACTIVE_BANNERS.filter((banner) => {
            return this.bannerService.isBannerVisible(banner)
        })
        const id = banners.length > 0 ? banners.pop().id : ''
        return this.getBannerComponentById(id)
    }

    renderCarousel() {
        return (
            <div class="glide">
                <div class="glide__track" data-glide-el="track">
                    <ul class="glide__slides">
                        {ACTIVE_BANNERS.map((banner) => {
                            return (
                                <li class="glide__slide">
                                    {this.getBannerComponentById(banner.id)}
                                </li>
                            )
                        })}
                    </ul>
                </div>
                {this.renderBullets()}
            </div>
        )
    }

    renderBullets() {
        return (
            <div
                class="bullets-container"
                onClick={this.updateControlView.bind(this)}
            >
                <div class="glide__bullets" data-glide-el="controls[nav]">
                    <button
                        ref="regularBannerControl"
                        class="glide__bullet filled"
                        data-glide-dir="=0"
                    />
                    <button
                        ref="giveawayBannerControl"
                        class="glide__bullet empty"
                        data-glide-dir="=1"
                    />
                </div>
            </div>
        )
    }

    updateControlView() {
        if (!this.glide) return

        if (this.glide.index === 0) {
            this.refs.regularBannerControl.classList.add('filled')
            this.refs.regularBannerControl.classList.remove('empty')

            this.refs.giveawayBannerControl.classList.add('empty')
            this.refs.giveawayBannerControl.classList.remove('filled')
        } else {
            this.refs.regularBannerControl.classList.add('empty')
            this.refs.regularBannerControl.classList.remove('filled')

            this.refs.giveawayBannerControl.classList.add('filled')
            this.refs.giveawayBannerControl.classList.remove('empty')
        }
    }

    getBannerComponentById(id: string) {
        switch (id) {
            case 'proudly_canadian':
                return <ProudlyCanadianBanner />
            case 'summer_giveaway':
                return <GiveawayBanner />
            default:
                return null
        }
    }
}
